var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMoreFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 16.1481V17.3333H4.2963C4.13244 17.3333 4 17.466 4 17.6296C4 17.7931 4.13244 17.9259 4.2963 17.9259H14.6667V19.1111C14.6667 19.2746 14.7991 19.4074 14.963 19.4074H18.5185C18.6824 19.4074 18.8148 19.2746 18.8148 19.1111V17.9259H19.7037C19.8676 17.9259 20 17.7931 20 17.6296C20 17.466 19.8676 17.3333 19.7037 17.3333H18.8148V16.1481C18.8148 15.9845 18.6824 15.8518 18.5185 15.8518H14.963C14.7991 15.8518 14.6667 15.9845 14.6667 16.1481Z",
    fill: "#99C540"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92593 10.5185V11.7036H4.2963C4.13244 11.7036 4 11.8364 4 11.9999C4 12.1635 4.13244 12.2962 4.2963 12.2962H9.92593V13.4814C9.92593 13.645 10.0584 13.7777 10.2222 13.7777H13.7778C13.9416 13.7777 14.0741 13.645 14.0741 13.4814V12.2962H19.7037C19.8676 12.2962 20 12.1635 20 11.9999C20 11.8364 19.8676 11.7036 19.7037 11.7036H14.0741V10.5185C14.0741 10.3549 13.9416 10.2222 13.7778 10.2222H10.2222C10.0584 10.2222 9.92593 10.3549 9.92593 10.5185Z",
    fill: "#99C540"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18519 4.88883V6.07401H4.2963C4.13244 6.07401 4 6.20675 4 6.37031C4 6.53386 4.13244 6.6666 4.2963 6.6666H5.18519V7.85179C5.18519 8.01534 5.31763 8.14808 5.48148 8.14808H9.03704C9.20089 8.14808 9.33333 8.01534 9.33333 7.85179V6.6666H19.7037C19.8676 6.6666 20 6.53386 20 6.37031C20 6.20675 19.8676 6.07401 19.7037 6.07401H9.33333V4.88883C9.33333 4.72527 9.20089 4.59253 9.03704 4.59253H5.48148C5.31763 4.59253 5.18519 4.72527 5.18519 4.88883Z",
    fill: "#99C540"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoreFilter);
export default __webpack_public_path__ + "static/media/icon_more_filter.00c99b46d0d3f7bf186060d1cadc3acf.svg";
export { ForwardRef as ReactComponent };